/**
 * Utility to determine which organization has access to specific features
 * based on the current environment.
 */
import { useEntitlementsStore } from '@/shared/stores/entitlements.store';

/**
 * Check if the custom RC chat panel is enabled via the org's entitlements.
 * Non-reactive — subscribe with `useEntitlementsStore` where a re-render is needed.
 */
export function isCustomChatEnabled(): boolean {
  return useEntitlementsStore.getState().hasFeature('rocketchat.custom');
}

/**
 * Extract the org slug from the current URL (first path segment).
 * Usable inside Zustand store actions where hooks are unavailable.
 */
export function getOrgSlugFromUrl(): string | null {
  const match = /^\/([^/]+)/.exec(window.location.pathname);
  return match ? match[1] : null;
}
